import { render, staticRenderFns } from "./RequestsIndex.vue?vue&type=template&id=986d4356&scoped=true"
import script from "./RequestsIndex.vue?vue&type=script&lang=js"
export * from "./RequestsIndex.vue?vue&type=script&lang=js"
import style0 from "./RequestsIndex.vue?vue&type=style&index=0&id=986d4356&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986d4356",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('986d4356')) {
      api.createRecord('986d4356', component.options)
    } else {
      api.reload('986d4356', component.options)
    }
    module.hot.accept("./RequestsIndex.vue?vue&type=template&id=986d4356&scoped=true", function () {
      api.rerender('986d4356', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/cancellation/RequestsIndex.vue"
export default component.exports